import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["id", "isAccordianBoxOpen"],
  _excluded2 = ["tiles"],
  _excluded3 = ["id", "isAccordianBoxOpen"],
  _excluded4 = ["id", "isAccordianBoxOpen"],
  _excluded5 = ["tiles"],
  _excluded6 = ["id", "isAccordianBoxOpen"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { tryParseJSON } from '@atlassian/mpac-utils';
import { useCallback, useState } from 'react';
export const useMpacConfiguration = () => {
  const {
    getMpacConfiguration
  } = useStatsig();
  const {
    result: initialConfig
  } = tryParseJSON(getMpacConfiguration());
  const [mpacConfiguration, setMpacConfiguration] = useState(initialConfig);
  const getSectionConfiguration = useCallback(section => {
    var _mpacConfiguration$se;
    return (_mpacConfiguration$se = mpacConfiguration === null || mpacConfiguration === void 0 ? void 0 : mpacConfiguration[section]) !== null && _mpacConfiguration$se !== void 0 ? _mpacConfiguration$se : [];
  }, [mpacConfiguration]);
  const updateSectionConfiguration = useCallback((section, updatedData) => {
    if (Array.isArray(updatedData)) {
      const cleanData = updatedData.map(_ref => {
        let {
            id,
            isAccordianBoxOpen
          } = _ref,
          rest = _objectWithoutProperties(_ref, _excluded);
        return rest;
      });
      const newConfig = _objectSpread(_objectSpread({}, mpacConfiguration), {}, {
        [section]: cleanData
      });
      setMpacConfiguration(newConfig);
    } else {
      var _tiles$map;
      const {
          tiles
        } = updatedData,
        sectionRest = _objectWithoutProperties(updatedData, _excluded2);
      const cleanedTiles = (_tiles$map = tiles === null || tiles === void 0 ? void 0 : tiles.map(_ref2 => {
        let {
            id,
            isAccordianBoxOpen
          } = _ref2,
          rest = _objectWithoutProperties(_ref2, _excluded3);
        return rest;
      })) !== null && _tiles$map !== void 0 ? _tiles$map : [];
      const newConfig = _objectSpread(_objectSpread({}, mpacConfiguration), {}, {
        [section]: _objectSpread(_objectSpread({}, sectionRest), {}, {
          tiles: cleanedTiles
        })
      });
      setMpacConfiguration(newConfig);
    }
  }, [mpacConfiguration]);
  const bulkUpdateConfiguration = useCallback((formState, mpacConfigurationKeys) => {
    const newConfig = _objectSpread({}, mpacConfiguration);
    mpacConfigurationKeys.forEach(key => {
      if (Array.isArray(formState[key])) {
        const cleanedData = formState[key].map(_ref3 => {
          let {
              id,
              isAccordianBoxOpen
            } = _ref3,
            rest = _objectWithoutProperties(_ref3, _excluded4);
          return rest;
        });
        newConfig[key] = cleanedData;
      } else {
        var _tiles$map2;
        const _formState$key = formState[key],
          {
            tiles
          } = _formState$key,
          sectionRest = _objectWithoutProperties(_formState$key, _excluded5);
        const cleanedTiles = (_tiles$map2 = tiles === null || tiles === void 0 ? void 0 : tiles.map(_ref4 => {
          let {
              id,
              isAccordianBoxOpen
            } = _ref4,
            rest = _objectWithoutProperties(_ref4, _excluded6);
          return rest;
        })) !== null && _tiles$map2 !== void 0 ? _tiles$map2 : [];
        newConfig[key] = _objectSpread(_objectSpread({}, sectionRest), {}, {
          tiles: cleanedTiles
        });
      }
    });
    setMpacConfiguration(newConfig);
  }, [mpacConfiguration]);
  return {
    mpacConfiguration,
    setMpacConfiguration,
    getSectionConfiguration,
    updateSectionConfiguration,
    bulkUpdateConfiguration
  };
};